import { Text } from '$components'
import { DogIcon } from '$components'
import { AnimatedOutlet } from '$components'

export function NoPetsEmptyState() {
  return (
    <div className="w-full p-stack-hero bg-surface-muted rounded-card flex flex-col items-center justify-center text-center">
      <DogIcon className="size-12 text-fg-link mb-stack-roomy" />

      <Text
        type="h3"
        className="mb-stack-roomy text-fg"
      >
        No pets yet
      </Text>

      <Text
        type="s"
        className="text-fg-subtle max-w-prose-sm"
      >
        This client doesn&apos;t have any pets registered yet. You can add pets to their profile when they bring one in.
      </Text>

      <AnimatedOutlet />
    </div>
  )
}
